<template>
  <div class="login-form">
    <p>{{heading}}</p>
    <input type="text" autocomplete="off" placeholder="LDAP" v-model="ldap" />
    <br />
    <Button v-if="this.saveLdap" :color="color" :buttonText="buttonText" @click.native.prevent="clickButton"></Button>
    <Button v-else :color="color" :buttonText="buttonText" @click.native.prevent="moveForward"></Button>
  </div>
</template>

<script>
import Button from '@/components/Button.vue'
import eventBus from '@/eventBus'

export default {
  name: 'loginForm',
  components: {
    Button,
  },
  data() {
    return {
      ldap: ''
    }
  },
  props: {
    heading: String,
    color: String,
    buttonText: String,
    path: String,
    saveLdap: Boolean
  },
  methods: {
    clickButton: function() {
      eventBus.$emit('save-ldap', this.ldap);
    },
    moveForward: function() {
      eventBus.$emit('check-ldap', this.ldap);
    }
  }
}
</script>

<style scoped>
  p {
    color: #fff;
    font-size: 30px;
    font-weight: 600;
    margin-bottom: 25px;
  }
  input {
    background: rgba(86, 116, 185, 0.36);
    border: none;
    border-radius: 286px;
    width: 286px;
    font-size: 24px;
    font-family: 'Open Sans', sans-serif;
    color: rgb(204, 204, 255);
    line-height: 1.2;
    margin-bottom: 25px;
    text-align: center;
    width: 286px;
    height: 70px;
    outline: none;
    z-index: 14;
  }
  ::placeholder{
    color: #ccccff;
  }
  ::-ms-input-placeholder {
    color: #ccccff;
  }
  input:focus::-webkit-input-placeholder { color: transparent; }
  input:focus:-ms-input-placeholder { color: transparent; }
  p {
    font-weight: bold;
  }
</style>